// ══════════════════════════════════════════════════════════
// DEFINICIÓN DE LOS 8 POWER-UPS
// ══════════════════════════════════════════════════════════

export interface PowerUpDefinition {
  id: string;
  name: string;
  description: string;
  icon: string;
  color: number;
  duration: number; // ms, 0 = instantáneo
  effectType: 'instant' | 'timed';
}

export const POWERUPS: PowerUpDefinition[] = [
  {
    id: 'curación',
    name: '❤️ Curación',
    description: 'Recupera 25% HP',
    icon: '❤️',
    color: 0xff0000,
    duration: 0,
    effectType: 'instant',
  },
  {
    id: 'rafaga',
    name: '⚡ Ráfaga',
    description: '+50% velocidad de giro 5s',
    icon: '⚡',
    color: 0xffff00,
    duration: 5000,
    effectType: 'timed',
  },
  {
    id: 'escudo',
    name: '🛡️ Escudo',
    description: 'Inmunidad a daño 4s',
    icon: '🛡️',
    color: 0x00aaff,
    duration: 4000,
    effectType: 'timed',
  },
  {
    id: 'explosion',
    name: '💥 Explosión',
    description: 'Onda expansiva (daño 15, knockback alto)',
    icon: '💥',
    color: 0xff8800,
    duration: 0,
    effectType: 'instant',
  },
  {
    id: 'furia',
    name: '🔥 Furia',
    description: 'Daño x2 durante 6s',
    icon: '🔥',
    color: 0xff4400,
    duration: 6000,
    effectType: 'timed',
  },
  {
    id: 'rayo',
    name: '⚡ Rayo',
    description: 'Golpea al rival más cercano (daño 12 fijo)',
    icon: '⚡',
    color: 0x4444ff,
    duration: 0,
    effectType: 'instant',
  },
  {
    id: 'torbellino',
    name: '🌀 Torbellino',
    description: 'Vórtice atrae rivales hacia ti 3s',
    icon: '🌀',
    color: 0x00ffcc,
    duration: 3000,
    effectType: 'timed',
  },
  {
    id: 'gigante',
    name: '📏 Gigante',
    description: 'Tamaño 1.5x, masa 2x 5s',
    icon: '📏',
    color: 0x88ff00,
    duration: 5000,
    effectType: 'timed',
  },
];
